export const COLLECTING = 'collecting';
export const TAKE_PERIOD_TIME = 'collected-and-waiting-to-take';
// negative
export const NOT_TAKEN = 'not-taken';
export const NOT_USED = 'not-used';
export const TERMS_NOT_COMPLIED = 'terms-not-complied';

// Common statuses campaign and bonuses
export const AVAILABLE = 'available';
export const PENDING = 'pending';
export const PENDING_BEFORE_WAGERING = 'pending-before-wagering'; // INFO: custom status. Bonus has 'pending' status twice (before collecting and before wagering)
export const WAGERING = 'wagering';
export const REJECTED = 'rejected';
export const WAGERED = 'wagered';
export const CONSUMED = 'consumed';
export const EXPIRED = 'expired';
export const CANCELLED = 'cancelled';
export const LOST = 'lost';
export const FORFEITED = 'forfeited';
export const ERROR = 'error';
// Custom statuses. Used only on the front end side
export const NOT_AVAILABLE = 'not-available';

export const BONUS_STATUSES = [
  AVAILABLE,
  PENDING,
  COLLECTING,
  TAKE_PERIOD_TIME,
  WAGERING,
  REJECTED,
  WAGERED,
  EXPIRED,
  CANCELLED,
  LOST,
  NOT_TAKEN,
  TERMS_NOT_COMPLIED,
  NOT_AVAILABLE,
  FORFEITED,
];

export const COMPLETED_STATUSES = [
  ERROR,
  REJECTED,
  WAGERED,
  CONSUMED,
  EXPIRED,
  CANCELLED,
  LOST,
  FORFEITED,
  NOT_TAKEN,
  TERMS_NOT_COMPLIED,
  NOT_USED,
];

export const DEPOSIT_TRIGGER_TYPE = 'deposit';
export const CASHBACK_TRIGGER_TYPE = 'cashback';
export const FREE_SPINS_FOR_JOIN_TRIGGER_TYPE = 'freespins-for-join';
export const FREE_SPINS_FOR_DEPOSIT_TRIGGER_TYPE = 'freespins-for-deposit';

export const CAMPAIGN_TRIGGER_TYPES = [
  DEPOSIT_TRIGGER_TYPE,
  CASHBACK_TRIGGER_TYPE,
  FREE_SPINS_FOR_JOIN_TRIGGER_TYPE,
  FREE_SPINS_FOR_DEPOSIT_TRIGGER_TYPE,
];

export const DEPOSIT_BONUS_TYPE = 'deposit';
export const CASHBACK_BONUS_TYPE = 'cashback';
export const FREE_SPINS_BONUS_TYPE = 'freespin';

export const BONUS_TYPES = [
  DEPOSIT_BONUS_TYPE,
  CASHBACK_BONUS_TYPE,
  FREE_SPINS_BONUS_TYPE,
];

export const DEPOSIT_CONTENT_CATEGORY_ID = 'deposit';
export const CASHBACK_CONTENT_CATEGORY_ID = 'cashback';

/**
 * Mechanics of bonuses
 * @type {string}
 */
export const WAGERING_BONUS_MECHANIC = 'wagering';
export const COLLECTING_BONUS_MECHANIC = 'collecting';
export const FREE_SPINS_BONUS_MECHANIC = 'freeSpins';

export const UNIFIED_PROMO_BONUSES_REDIRECTS = {
  TO_BONUS: 'TO_BONUS',
  TO_ALL_BONUS_PAGE: 'TO_ALL_BONUS_PAGE',
};

export const REDIRECT_TO_UNIFIED_PROMO_LOBBY_KEY =
  'REDIRECT_TO_UNIFIED_PROMO_LOBBY_KEY';
export const REDIRECT_TO_UNIFIED_PROMO_LOBBY_ADDITIONAL_DATA =
  'REDIRECT_TO_UNIFIED_PROMO_LOBBY_ADDITIONAL_DATA';
